import {common} from './common';
import {user} from './user';
import {Subject} from 'rxjs';
import {interact, URLS} from 'fire-wind-water';
import {auth} from './auth';
import {data} from './data';
import {replaceDomain} from '../help/url';

class Link {
  instance: any;
  customFormId: any;
  customFormInfo: any;
  jumpUrl: string;
  meetingInfo: any = {};
  memberInfo: any;
  isJump: boolean = false;

  constructor() {
  }

  init(o) {
    const $s = new Subject<any>();
    const isNotLink = URLS.getURL('isNotLink');
    this.instance = o;
    if (isNotLink == '1') {
      this.instance.skIsNotLink = 1;
    }
    this.jumpUrl = '';
    setTimeout(() => {
      if (this[`identity${o.identity}`]) {
        this.isJump = false;
        this[`identity${o.identity}`]($s);
      }
    });
    return $s;
  }

  async identity1(s) {
    if (interact.isWeChat && user.openId && auth.weChatId && auth.weChatId !== '0') {
      await this.initWechat();
    }
    await this.checkRegistration();
    s.next('link-end');
    s.complete();
  }

  async identity2(s) {
    if (interact.isWeChat && user.openId && auth.weChatId && auth.weChatId !== '0') {
      await this.initWechat();
    }
    if (user.wxInfo.subscribe != 1) {
      await this.showWeChatQrCode();
    }
    await this.checkRegistration();
    s.next('link-end');
    s.complete();
  }

  async identity3(s) {
    if (interact.isWeChat && user.openId && auth.weChatId && auth.weChatId !== '0') {
      await this.initWechat();
    }
    const arr = ['customForm'];
    const type = this.instance.meetingType;
    if (type == 2 || type == 3 || arr.indexOf(this.instance.skObjectType) !== -1) {
      await this.checkRegistration();
      if (user.status.signupStatus === 'allow' && !user.session) {
        await this.initMemberForm();
      }
    } else {
      if (!user.session) {
        await this.initMemberForm();
      }
    }

    s.next('link-end');
    s.complete();
  }

  async identity4(s) {
    await this.checkRegistration();
    if (user.status.signupStatus === 'allow') {
      await this.initMeetingForm();
    }
    s.next('link-end');
    s.complete();
  }

  async showWeChatQrCode() {
    const info = {
      weChatId: auth.weChatId,
      qrType: 2,
      objId: this.instance.skObjectId
    };
    return new Promise(resolve => {
      data.weChatQrCode(info).subscribe(res => {
        if (res) {
          user.wxQrCode.qrCodeUrl = res.qrCodeUrl;
          user.wxQrCode.qrName = res.qrName;
        }
        resolve(res);
      });
    });
  }

  async initMemberForm() {
    const info = {
      tenantId: common.tenantId || '',
      schemaId: common.schemaId,
      formId: this.instance.memberFormId,
      memberFormId: this.instance.memberFormId
    };
    return new Promise(resolve => {
      data.getForNewForm(info).subscribe(res => {
        if (res) {
          this.initMemberUrl(res);
        }
        resolve('member-form');
      });
    });
  }

  initMemberUrl(res) {
    this.memberInfo = res;
    const type = interact.isMobile ? 'wap' : 'pc';
    const weChatId = URLS.getURL('weChatId');
    let murl = res.originUrl ? res.originUrl[type] : '';
    let turl = window.location.href;
    if (weChatId) {
      murl = URLS.updateSearchParam('weChatId', weChatId, murl);
    }
    if (user.wxInfo.authCode) {
      murl = URLS.updateSearchParam('authCode', user.wxInfo.authCode, murl);
    }

    turl = URLS.removeSearchParam(turl, 'token', 'retCode', 'puzzleFlag', 'excode', 'scope');
    murl = URLS.updateSearchParam('backUrl', encodeURIComponent(turl), murl);
    // murl += interact.isWeChat ? '#wechat_redirect' : '';
    this.jumpUrl = murl;
    this.isJump = true;
    if (this.instance.skIsNotLink !== 1) {
      window.location.href = replaceDomain(murl);
    }
  }

  async initWechat() {
    await user.getOpenId();
    return new Promise(resolve => {
      resolve('openId-member');
    });
  }

  async initMeetingForm(): Promise<any> {
    await this.initMeeting();
    await this.initCustomForm();
    this.initCustomFormUrl();
    return new Promise(resolve => {
      resolve('link-end');
    });
  }

  initCustomFormUrl() {
    const type = interact.isMobile ? 'mobile' : 'pc';
    const template = this.customFormInfo.template[type];
    const customFormId = this.customFormId;
    const configId = template.configId;
    const url = template.formalUrl + '?customFormId=' + customFormId + '&configId=' + configId +
      (this.instance.weChatId ? ('&wechatId=' + this.instance.weChatId) : '') + '&returnUrl=' +
      encodeURIComponent(window.location.href);
    this.jumpUrl = url;
    this.isJump = true;
    if (this.instance.skIsNotLink !== 1) {
      window.location.href = replaceDomain(url);
    }
  }

  async initCustomForm() {
    const info = {
      tenantId: common.tenantId,
      customFormId: this.customFormId,
      globalUserId: user.globalUserId
    };
    return new Promise(resolve => {
      data.getCustomForm(info).subscribe(res => {
        if (res) {
          this.customFormInfo = res;
        }
        resolve(this.customFormInfo);
      });
    });
  }

  async initMeeting() {
    if (parseInt(this.instance.meetingType, 10) === 3) {
      await this.initSeminar();
    }
    if (parseInt(this.instance.meetingType, 10) === 2) {
      await this.initWebinar();
    }
    return new Promise(resolve => {
      resolve(this.customFormId);
    });
  }

  async initWebinar(): Promise<any> {
    const info = {
      instanceId: this.instance.meetingInstanceId,
      webinarId: '',
      includeCustomField: false,
      tenantId: common.tenantId
    };
    return new Promise(resolve => {
      data.getWebinar(info).subscribe(res => {
        if (res) {
          this.customFormId = res.customFormId;
          this.meetingInfo = res;
        }
        resolve(this.customFormId);
      });
    });
  }

  async initSeminar(): Promise<any> {
    const info = {
      instanceId: this.instance.meetingInstanceId
    };
    return new Promise(resolve => {
      data.getSeminar(info).subscribe(res => {
        if (res) {
          this.customFormId = res.registerFormId;
          this.meetingInfo = res;
        }
        resolve(this.customFormId);
      });
    });
  }

  // 检查用户状态
  checkRegistration() {
    const info: any = {
      instanceId: this.instance.meetingInstanceId,
      tenantId: common.tenantId,
      globalUserId: user.globalUserId,
      session: user.session || '',
      sess: user.session || '',
      openId: user.openId || ''
    };
    const type = {
      poll: 'pollId',
      customForm: 'customFormId',
      questionary: 'questionnaireId'
    };
    info[type[this.instance.skObjectType]] = this.instance.skObjectId;
    if (this.instance.skObjectType === 'questionary') {
      info.includeDeFormData = 1;
      info.checkRegisterFormStatus = 1;
    }
    if(!type[this.instance.skObjectType]){
      return new Promise(resolve => {
        resolve('userStatus');
      });
    }
    return new Promise(resolve => {
      data.checkRegistration(info, this.instance.skObjectType).subscribe(data => {
        if (data) {
          user.updateStatus(data, data.formData || []);
        }
        resolve('userStatus');
      });
    });
  }

}

export const link = new Link();